"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_layout_1 = require("@carvana/helios-layout");
var WSYSCallOut = function (_a) {
    var incentiveAmount = _a.incentiveAmount, salesTaxSavingsAmount = _a.salesTaxSavingsAmount, savings = _a.savings;
    var hasOnlySavings = incentiveAmount <= 0 && salesTaxSavingsAmount > 0;
    var hasOnlyIncentive = salesTaxSavingsAmount <= 0 && incentiveAmount > 0;
    var hasIncentiveAndSavings = salesTaxSavingsAmount > 0 && incentiveAmount > 0;
    return ((0, jsx_runtime_1.jsx)(helios_layout_1.Banner, __assign({ type: "success", open: true, className: "borderless" }, { children: (0, jsx_runtime_1.jsxs)(helios_layout_1.Banner.Headline, { children: [hasOnlySavings && (0, jsx_runtime_1.jsx)("span", { children: "Get ".concat(savings, " more with your sales tax savings") }), hasOnlyIncentive && (0, jsx_runtime_1.jsx)("span", { children: "Get ".concat(savings, " more with your trade in savings") }), hasIncentiveAndSavings && ((0, jsx_runtime_1.jsx)("span", __assign({ className: "incentive-text" }, { children: "Get ".concat(savings, " more with your trade in and sales tax savings") })))] }) })));
};
exports.default = WSYSCallOut;
